import script from "./ServicerDetailsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicerDetailsCard.vue?vue&type=script&setup=true&lang=ts"

import "./ServicerDetailsCard.vue?vue&type=style&index=0&id=352f0c9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352f0c9a"]])

export default __exports__